export const helpSections = [
  {
    id: "about",
    // //: "🏛️",
    title: "",
    purpose:
      "Quant Kubera is an analytical platform designed for NSE intraday and end-of-day stock analysis.",
    points: [
      {
        title: "Real-Time Analysis",
        desc: "Provides intraday signals using RSI, MACD, VWAP, UT Bot and Bollinger Band analysis.",
      },
      {
        title: "EOD Analysis",
        desc: "Provides end-of-day trend analysis with closing strength, rebound strength, distance to high and pivot levels.",
      },
      {
        title: "Index Coverage",
        desc: "Supports NIFTY 50, NIFTY BANK, NIFTY IT, NIFTY NEXT 50 and NIFTY MIDCAP 100.",
      },
      {
        title: "Important Note",
        desc: "Quant Kubera does not provide financial advice, trade execution or guaranteed prediction accuracy.",
      },
    ],
  },

  {
    id: "getting-started",
    //: "🚀",
    title: "Getting Started",
    purpose:
      "Login, choose your market mode, use the profile menu and access platform features.",
    images: [
      {
        title: "Profile Menu",
        src: "/guide-images/profile-menu.png",
        desc: "Shows username, My Watchlist, Features dropdown and Logout option.",
      },
    ],
    table: [
      {
        label: "NSE",
        value: "Indian stock market data. All platform features are available.",
      },
      {
        label: "Global",
        value: "International stock screener data with limited feature set.",
      },
      {
        label: "Profile Menu",
        value: "Access username, My Watchlist, Features and Logout.",
      },
    ],
  },

  {
    id: "navigation-menu",
    //: "🧭",
    title: "Navigation Menu",
    purpose:
      "The top navigation menu gives access to all major Quant Kubera modules.",
    table: [
      { label: "One Stock", value: "In-depth analysis of one saved stock." },
      { label: "Live News", value: "Real-time market news feed." },
      {
        label: "Live Trend",
        value: "Intraday signal table for selected index stocks.",
      },
      {
        label: "EOD Trend",
        value: "End-of-day analysis with strength and pivot metrics.",
      },
      {
        label: "HeatMap",
        value: "Visual percentage-change grid for selected index stocks.",
      },
      {
        label: "Option Chain",
        value: "NSE option chain viewer with OI and PCR analysis.",
      },
      {
        label: "Max Pain",
        value: "Max pain strike calculator with OI chart.",
      },
      {
        label: "Most Active Contracts",
        value: "Highest-volume option contracts table.",
      },
    ],
  },

  {
    id: "supported-indices",
    //: "📈",
    title: "Supported Indices",
    purpose:
      "Quant Kubera supports major NSE indices and remembers your last selected index.",
    table: [
      {
        label: "NIFTY 50",
        value: "India's benchmark index containing top 50 companies.",
      },
      {
        label: "NIFTY BANK",
        value: "Leading banking and financial services stocks.",
      },
      {
        label: "NIFTY IT",
        value: "Major information technology companies.",
      },
      {
        label: "NIFTY NEXT 50",
        value: "Companies ranked 51-100 by market capitalisation.",
      },
      {
        label: "NIFTY MIDCAP 100",
        value: "Top 100 mid-capitalisation companies.",
      },
    ],
  },

  {
    id: "dashboard",
    //: "📊",
    title: "Dashboard",
    purpose:
      "A consolidated market overview showing index movement, market breadth, top gainers, top losers and most active stocks.",
    images: [
      {
        title: "Dashboard Overview",
        src: "/guide-images/dashboard.png",
        desc: "Shows Top Gainers, Top Losers, Most Active stocks, Advances, Declines and selected index price.",
      },
    ],
    points: [
      {
        title: "Index Selector",
        desc: "Select NIFTY 50, NIFTY BANK, NIFTY IT, NIFTY NEXT 50 or NIFTY MIDCAP 100.",
      },
      {
        title: "Quick Index Chips",
        desc: "Shortcut chips provide one-click navigation to the complete stock table.",
      },
      {
        title: "Market Breadth",
        desc: "Shows Advances, Declines and Unchanged stocks.",
      },
      {
        title: "Market Movers",
        desc: "Shows Top Gainers, Top Losers and Most Active stocks.",
      },
      {
        title: "Refresh",
        desc: "The As on timestamp shows the latest update time. Use refresh // for manual refresh.",
      },
    ],
  },

  {
    id: "stock-test-detail",
    //: "📋",
    title: "Stock Test Detail",
    purpose:
      "A comprehensive table showing all stocks in the selected index with price data and daily signal.",
    images: [
      {
        title: "Complete Stock Table",
        src: "/guide-images/stock-test-detail.png",
        desc: "Displays stock symbol, price, open, close, percentage change, volume and RSI & MACD trend.",
      },
    ],
    table: [
      {
        label: "Company or Ticker",
        value: "Stock symbol. Click to open Stock Detail Page.",
      },
      { label: "Price", value: "Last Traded Price." },
      { label: "Open", value: "Day opening price." },
      { label: "Close", value: "Previous session close." },
      { label: "% Change", value: "Percentage change from previous close." },
      { label: "Low / High", value: "Intraday price range." },
      { label: "Volume", value: "Total traded volume." },
      {
        label: "RSI & MACD Trend",
        value: "Combined momentum signal: Bullish, Bearish or Neutral.",
      },
    ],
  },

  {
    id: "live-news",
    //: "📰",
    title: "Live News",
    purpose:
      "A real-time news feed displaying the latest financial and market news articles.",
    images: [
      {
        title: "Live News Feed",
        src: "/guide-images/live-news.png",
        desc: "Displays news cards with headline, publication date and source.",
      },
    ],
    points: [
      {
        title: "Search News",
        desc: "Search news by stock symbol.",
      },
      {
        title: "News Cards",
        desc: "Each card shows headline, date, time and source.",
      },
      {
        title: "Open Article",
        desc: "Click the headline to open the full article in a new tab.",
      },
      {
        title: "Refresh",
        desc: "Use the refresh // to fetch latest articles.",
      },
    ],
  },

  {
    id: "live-trend",
    //: "⚡",
    title: "Live Trend",
    purpose:
      "A real-time intraday signal table showing indicators for every stock in the selected index.",
    images: [
      {
        title: "Live Trend Table",
        src: "/guide-images/live-trend.png",
        desc: "Shows LTP, VWAP, RSI & MACD Trend, VWAP Trend, UT Signal, BB Signal, OHLC, percentage change and year high.",
      },
    ],
    points: [
      {
        title: "Quote Refresh",
        desc: "Quote data like LTP, OHLC and volume refreshes every 2 minutes.",
      },
      {
        title: "Signal Refresh",
        desc: "Signal data like RSI, MACD, VWAP, UT Bot and BB refreshes every 3 minutes.",
      },
      {
        title: "Filtering",
        desc: "Filter stocks by All, Bullish, Bearish or Neutral.",
      },
      {
        title: "Export Options",
        desc: "Send email report or download CSV/Excel.",
      },
    ],
    table: [
      { label: "LTP", value: "Last Traded Price." },
      { label: "VWAP", value: "Volume Weighted Average Price." },
      {
        label: "RSI & MACD Trend",
        value: "Bullish, Bearish or Neutral momentum signal.",
      },
      { label: "VWAP Trend", value: "Whether price is above or below VWAP." },
      { label: "UT Signal", value: "UT Bot trailing stop signal." },
      {
        label: "BB Signal",
        value: "Bollinger Band and Awesome Oscillator signal.",
      },
      { label: "% Change", value: "Percentage change from previous close." },
      { label: "Year High", value: "52-week high price." },
    ],
  },

  {
    id: "eod-trend",
    //: "🌙",
    title: "EOD Trend",
    purpose:
      "End-of-day analysis using previous trading session data for post-market review and next-day planning.",
    images: [
      {
        title: "EOD Trend Table",
        src: "/guide-images/eod-trend.png",
        desc: "Shows LTP, RSI & MACD Trend, OHLC, percentage change, R1/S1 pivot levels and strength metrics.",
      },
    ],
    table: [
      {
        label: "Closing Strength",
        value:
          "Formula: (Close - Low) / (High - Low) x 100. Shows close position within the day's range.",
      },
      {
        label: "Rebound Strength",
        value:
          "Formula: (Min(Close, Open) - Low) / (High - Low) x 100. Shows recovery from the day's low.",
      },
      {
        label: "Distance to High",
        value:
          "Formula: (High - Close) / (High - Low) x 100. Shows how far close was from high.",
      },
      {
        label: "R1",
        value: "Classic pivot first resistance.",
      },
      {
        label: "S1",
        value: "Classic pivot first support.",
      },
    ],
    points: [
      {
        title: "Green Signal",
        desc: "Strong close or strong recovery.",
      },
      {
        title: "Yellow Signal",
        desc: "Balanced or neutral close.",
      },
      {
        title: "Red Signal",
        desc: "Weak close or selling pressure.",
      },
    ],
  },

  {
    id: "heatmap",
    //: "🧩",
    title: "Heatmap",
    purpose:
      "A visual representation of all stocks in the selected index, colour-coded by percentage change.",
    images: [
      {
        title: "Heatmap Overview",
        src: "/guide-images/heatmap.png",
        desc: "Green shades indicate gains, red shades indicate losses and grey indicates flat movement.",
      },
    ],

    points: [
      {
        title: "Tile Information",
        desc: "Each tile displays symbol, price and percentage change.",
      },
      {
        title: "Interpretation",
        desc: "Mostly green means broad buying, mostly red means broad selling, mixed colours indicate sector rotation.",
      },
      {
        title: "Navigation",
        desc: "Click any tile to open Stock Detail Page.",
      },
    ],
    heatmapColors: [
      {
        color: "#0f7a2f",
        label: "+5% and above",
        meaning: "Strong rally",
      },
      {
        color: "#1fa34a",
        label: "+3% to +4.99%",
        meaning: "Solid gain",
      },
      {
        color: "#7bc08a",
        label: "+1% to +2.99%",
        meaning: "Mild positive",
      },
      {
        color: "#9ca3af",
        label: "0%",
        meaning: "No movement",
      },
      {
        color: "#f28b8b",
        label: "-0.01% to -0.99%",
        meaning: "Mild decline",
      },
      {
        color: "#e74c4c",
        label: "-1% to -2.99%",
        meaning: "Notable decline",
      },
      {
        color: "#b91c1c",
        label: "-3% and below",
        meaning: "Sharp decline",
      },
    ],
  },

  // {
  //   id: "stock-detail",
  //   //: "🔍",
  //   title: "Stock Detail Page",
  //   purpose:
  //     "Comprehensive stock analysis with price header, signals, pivots, VWAP analysis, fundamentals, moving averages and charts.",
  //   images: [
  //     {
  //       title: "Price Header & Quant Kubera Insights",
  //       src: "/guide-images/stock-detail-header.png",
  //       desc: "Displays LTP, percentage change, open, close, forecast price, VWAP, RSI & MACD, VWAP Momentum, UT Bot and BB Signal.",
  //     },
  //     {
  //       title: "Near Pivots & VWAP Key Levels",
  //       src: "/guide-images/stock-detail-vwap.png",
  //       desc: "Shows Key Resistance, Key Support, VWAP, Stop Loss and VWAP analysis summary.",
  //     },
  //     {
  //       title: "Pivot Levels, Price Ranges & Returns",
  //       src: "/guide-images/stock-detail-pivots.png",
  //       desc: "Displays R3-S3 levels using Classic, Fibonacci, Camarilla, Woodie and Demark methods, along with forecast range, day range, 52-week range and returns.",
  //     },
  //     {
  //       title: "Technical, Fundamental & Moving Averages",
  //       src: "/guide-images/stock-detail-fundamentals.png",
  //       desc: "Shows technical factors, fundamental factors, valuation, profitability, ownership, risk and moving averages.",
  //     },
  //     {
  //       title: "MACD & Price Trend Charts",
  //       src: "/guide-images/stock-detail-macd.png",
  //       desc: "Shows MACD line, Signal line, Histogram and synchronized price trend chart.",
  //     },
  //     {
  //       title: "Candlestick Chart & VWAP Signals",
  //       src: "/guide-images/stock-detail-candle.png",
  //       desc: "Interactive candlestick chart with VWAP overlay, BUY signals and SELL signals.",
  //     },
  //   ],
  //   points: [
  //     {
  //       title: "Price Header",
  //       desc: "Shows company name, symbol, LTP, percentage change, open, close, forecast price and VWAP.",
  //     },
  //     {
  //       title: "Quant Kubera Insights",
  //       desc: "Four independent panels: RSI & MACD, VWAP Momentum, UT Bot and BB Signal.",
  //     },
  //     {
  //       title: "Near Pivots",
  //       desc: "Shows Key Resistance, Key Support, VWAP and Stop Loss.",
  //     },
  //     {
  //       title: "Pivot Levels",
  //       desc: "Supports Day/Weekly view and multiple pivot calculation methods.",
  //     },
  //     {
  //       title: "Returns",
  //       desc: "Displays 1W, 1M, YTD, 1Y, 3Y and 5Y returns.",
  //     },
  //     {
  //       title: "Charts",
  //       desc: "Includes MACD chart, price trend chart and candlestick chart.",
  //     },
  //   ],
  // },
  {
    id: "stock-detail",
    title: "Stock Detail Page",
    purpose:
      "Comprehensive stock analysis with price header, intraday and EOD signals, Smart Money Flow, pivots, VWAP analysis, fundamentals, moving averages and charts.",
    images: [
      {
        title: "Price Header & Quant Kubera Insights",
        src: "/guide-images/stock-detail-header.png",
        desc: "Displays LTP, percentage change, open, close, forecast price, VWAP, RSI & MACD, VWAP Momentum, UT Bot, BB Signal and Smart Money Flow.",
      },
      {
        title: "Near Pivots & VWAP Key Levels",
        src: "/guide-images/stock-detail-vwap.png",
        desc: "Shows Key Resistance, Key Support, VWAP, Stop Loss and VWAP analysis summary.",
      },
      {
        title: "Pivot Levels, Price Ranges & Returns",
        src: "/guide-images/stock-detail-pivots.png",
        desc: "Displays R3-S3 levels using Classic, Fibonacci, Camarilla, Woodie and Demark methods, along with forecast range, day range, 52-week range and returns.",
      },
      {
        title: "Technical, Fundamental & Moving Averages",
        src: "/guide-images/stock-detail-fundamentals.png",
        desc: "Shows technical factors, fundamental factors, valuation, profitability, ownership, risk and moving averages.",
      },
      {
        title: "MACD & Price Trend Charts",
        src: "/guide-images/stock-detail-macd.png",
        desc: "Shows MACD line, Signal line, Histogram and synchronized price trend chart.",
      },
      {
        title: "Candlestick Chart & VWAP Signals",
        src: "/guide-images/stock-detail-candle.png",
        desc: "Interactive candlestick chart with VWAP overlay, BUY signals and SELL signals.",
      },
    ],
    points: [
      {
        title: "Price Header",
        desc: "Shows company name, symbol, LTP, percentage change, open, close, forecast price and VWAP.",
      },
      {
        title: "RSI & MACD Signal",
        desc: "Shows Bullish, Bearish or Neutral momentum using RSI and MACD confirmation.",
      },
      {
        title: "VWAP Momentum",
        desc: "Shows whether the stock is trading above or below VWAP during the session.",
      },
      {
        title: "UT Bot Signal",
        desc: "ATR-based trend-following signal used to detect bullish or bearish trend shifts.",
      },
      {
        title: "BB Signal",
        desc: "Bollinger Band and Awesome Oscillator based signal for trend and volatility confirmation.",
      },
      {
        title: "Smart Money Flow",
        desc: "Shows Intraday and EOD buying or selling pressure using CMF, OBV Trend, Relative Volume, VWAP and MFI.",
      },
      {
        title: "Near Pivots",
        desc: "Shows Key Resistance, Key Support, VWAP and Stop Loss.",
      },
      {
        title: "Pivot Levels",
        desc: "Supports Day/Weekly view and multiple pivot calculation methods.",
      },
      {
        title: "Returns",
        desc: "Displays 1W, 1M, YTD, 1Y, 3Y and 5Y returns.",
      },
      {
        title: "Charts",
        desc: "Includes MACD chart, price trend chart and candlestick chart.",
      },
    ],
  },

  {
    id: "one-stock",
    //: "⭐",
    title: "One Stock",
    purpose: "Save and monitor a single stock with full analysis.",
    images: [
      {
        title: "One Stock Analysis",
        src: "/guide-images/one-stock.png",
        desc: "Shows selected stock signals, candlestick chart, OHLC, VWAP, PCR, resistance, support and moving averages.",
      },
    ],
    points: [
      {
        title: "Search Stock",
        desc: "Search a stock or index with minimum 2 characters.",
      },
      {
        title: "Saved Selection",
        desc: "Your selected stock persists across sessions.",
      },
      {
        title: "Remove Stock",
        desc: "Remove saved stock and search for a new one.",
      },
    ],
  },

  {
    id: "watchlist",
    //: "🔔",
    title: "Watchlist",
    purpose:
      "Track multiple stocks with live signals, custom trade parameters and email notifications.",
    images: [
      {
        title: "Watchlist Overview",
        src: "/guide-images/watchlist.png",
        desc: "Shows stocks with LTP, close, percentage change, signals, upside, entry, exit and notification toggle.",
      },
    ],
    table: [
      {
        label: "Company",
        value: "Stock symbol. Click row to open Stock Detail Page.",
      },
      { label: "LTP", value: "Last Traded Price." },
      { label: "Close", value: "Previous close." },
      { label: "% Change", value: "Percentage movement." },
      { label: "VWAP Trend", value: "Intraday VWAP signal." },
      { label: "UT Bot Signal", value: "UT Bot signal." },
      { label: "BB Signal", value: "Bollinger Band signal." },
      { label: "RSI & MACD Trend", value: "Combined momentum signal." },
      { label: "Upside %", value: "Custom editable target." },
      { label: "Entry Price", value: "Custom editable entry price." },
      { label: "Exit Price", value: "Custom editable exit price." },
      { label: "Notify", value: "Enable or disable email alerts." },
    ],
    points: [
      {
        title: "Notification OFF",
        desc: "Bell with slash means alerts are disabled.",
      },
      {
        title: "Notification ON",
        desc: "Solid bell means email alerts are active.",
      },
      {
        title: "Channels",
        desc: "Email is active. Telegram and WhatsApp are coming soon.",
      },
    ],
  },

  {
    id: "option-chain",
    //: "📈",
    title: "Option Chain",
    purpose:
      "View NSE option chain with OI analysis, PCR signals and built-up indicators.",
    images: [
      {
        title: "Option Chain Overview",
        src: "/guide-images/option-chain.png",
        desc: "Shows contract selector, expiry date, LTP, Max Pain, ATM Put/Call Premium Ratio, PCR signal and ATM strike details.",
      },
    ],
    points: [
      {
        title: "Selection Controls",
        desc: "Choose contract, expiry date, search symbol and filter strikes.",
      },
      {
        title: "Summary Panel",
        desc: "Shows selected contract, LTP, Max Pain, ATM premium ratio and PCR signal.",
      },
      {
        title: "ATM Strike Detail",
        desc: "Displays CE and PE LTP, OI change and built-up indicator.",
      },
      {
        title: "Export Options",
        desc: "Save snapshot, export CSV or export Excel.",
      },
    ],
    table: [
      { label: "LB", value: "Long Build Up." },
      { label: "SB", value: "Short Build Up." },
      { label: "SC", value: "Short Covering." },
      { label: "LC", value: "Long Covering." },
      {
        label: "PCR Signal",
        value: "Bullish, Bearish or Neutral option sentiment.",
      },
    ],
  },

  {
    id: "max-pain",
    //: "🎯",
    title: "Max Pain",
    purpose:
      "Visualise the max pain strike using option open interest distribution.",
    images: [
      {
        title: "Max Pain Chart",
        src: "/guide-images/max-pain.png",
        desc: "Shows LTP, max pain strike, Put OI and Call OI distribution across strikes.",
      },
    ],
    points: [
      {
        title: "Max Pain Strike",
        desc: "The strike where option writers may experience the least payout.",
      },
      {
        title: "Highest Call OI",
        desc: "Often acts as resistance.",
      },
      {
        title: "Highest Put OI",
        desc: "Often acts as support.",
      },
      {
        title: "OI Bar Chart",
        desc: "Visual comparison of Put OI and Call OI across strikes.",
      },
    ],
  },

  {
    id: "most-active-contracts",
    //: "🔥",
    title: "Most Active Contracts",
    purpose:
      "View highest-volume option contracts across NSE indices and stocks.",
    images: [
      {
        title: "Most Active Contracts Table",
        src: "/guide-images/most-active-contracts.png",
        desc: "Shows instrument type, symbol, expiry date, option type, strike price, LTP, percentage change, volume, value, OI and underlying price.",
      },
    ],
    table: [
      { label: "Instrument Type", value: "For example Index Options." },
      { label: "Symbol", value: "Underlying index or stock." },
      { label: "Expiry Date", value: "Contract expiry date." },
      { label: "Option Type", value: "Call or Put." },
      { label: "Strike Price", value: "Strike price of the contract." },
      { label: "LTP", value: "Option premium." },
      { label: "% Change", value: "Premium change." },
      { label: "Volume", value: "Total contracts traded." },
      { label: "Value", value: "Traded value in rupees lakhs." },
      { label: "Open Interest", value: "Outstanding contracts." },
      { label: "Underlying", value: "Current underlying price." },
    ],
  },

  {
    id: "ai-assistant",
    //: "🤖",
    title: "Kubera AI Assistant",
    purpose:
      "AI-powered conversational assistant for contextual stock analysis.",
    images: [
      {
        title: "Kubera AI Assistant",
        src: "/guide-images/ai-assistant.png",
        desc: "Floating assistant opens from the bottom-right corner and supports contextual questions.",
      },
    ],
    points: [
      {
        title: "Open Assistant",
        desc: "Click the floating AI // at the bottom-right corner.",
      },
      {
        title: "Ask Question",
        desc: "Type your question in the input field.",
      },
      {
        title: "Copy Response",
        desc: "Use copy // to copy the AI response.",
      },
      {
        title: "Important Note",
        desc: "AI assistant provides analytical insights only and not financial advice.",
      },
    ],
  },

  {
    id: "feedback",
    //: "💬",
    title: "Feedback",
    purpose:
      "Share feedback, suggestions or report issues to the Quant Kubera team.",
    images: [
      {
        title: "Feedback Form",
        src: "/guide-images/feedback.png",
        desc: "Submit first name, last name, email and feedback message.",
      },
    ],
  },

  {
    id: "search",
    //: "🔎",
    title: "Search",
    purpose:
      "Search stocks and indices from the navbar, One Stock page and Watchlist page.",
    images: [
      {
        title: "Navbar Search",
        src: "/guide-images/search.png",
        desc: "Enter at least 2 characters to view results under Indices and Stocks.",
      },
    ],
    points: [
      {
        title: "Navbar Search",
        desc: "Available on every page.",
      },
      {
        title: "One Stock Search",
        desc: "Used to save a single stock for monitoring.",
      },
      {
        title: "Watchlist Search",
        desc: "Used to add stocks to Watchlist.",
      },
    ],
  },

  // {
  //   id: "signal-reference",
  //   //: "🚦",
  //   title: "Signal Reference",
  //   purpose:
  //     "Explains signal meanings, bullish/bearish conditions and colour coding used across the platform.",
  //   table: [
  //     {
  //       label: "RSI & MACD Trend",
  //       value:
  //         "Bullish when RSI > 55 and MACD is above Signal. Bearish when RSI < 45 and MACD is below Signal. Otherwise Neutral.",
  //     },
  //     {
  //       label: "VWAP Trend",
  //       value:
  //         "Bullish when price is above VWAP. Bearish when price is below VWAP.",
  //     },
  //     {
  //       label: "UT Bot",
  //       value:
  //         "Bullish when price crosses above trailing stop. Bearish when price crosses below trailing stop.",
  //     },
  //     {
  //       label: "BB Signal",
  //       value:
  //         "Bullish when Bollinger Band expands upward with positive AO. Bearish when it expands downward with negative AO.",
  //     },
  //   ],
  //   points: [
  //     { title: "🟢 Green", desc: "Bullish / Positive signal." },
  //     { title: "🔴 Red", desc: "Bearish / Negative signal." },
  //     { title: "🟡 Yellow", desc: "Neutral / Awaiting confirmation." },
  //     {
  //       title: "🔵 Blue",
  //       desc: "Informational values such as VWAP, Max Pain or reference levels.",
  //     },
  //     {
  //       title: "Signal Confluence",
  //       desc: "No single signal should be used in isolation. When three or more signals converge, confidence improves, but no signal guarantees results.",
  //     },
  //   ],
  // },
  {
    id: "signal-reference",
    title: "Signal Reference",
    purpose:
      "Explains signal meanings, bullish/bearish conditions and colour coding used across the platform.",
    table: [
      {
        label: "RSI & MACD Trend",
        value:
          "Bullish when RSI > 55 and MACD is above Signal. Bearish when RSI < 45 and MACD is below Signal. Otherwise Neutral.",
      },
      {
        label: "VWAP Trend",
        value:
          "Bullish when price is above VWAP. Bearish when price is below VWAP.",
      },
      {
        label: "UT Bot",
        value:
          "Bullish when price crosses above trailing stop. Bearish when price crosses below trailing stop.",
      },
      {
        label: "BB Signal",
        value:
          "Bullish when Bollinger Band expands upward with positive AO. Bearish when it expands downward with negative AO.",
      },
      {
        label: "Smart Money",
        value:
          "Strong Accumulation means strong buying pressure. Accumulation means moderate buying pressure. Neutral means no clear money flow. Distribution and Heavy Distribution indicate selling pressure.",
      },
    ],
    points: [
      { title: "🟢 Green", desc: "Bullish / Accumulation / Positive signal." },
      { title: "🔴 Red", desc: "Bearish / Distribution / Negative signal." },
      { title: "🟡 Yellow", desc: "Neutral / Awaiting confirmation." },
      {
        title: "🔵 Blue",
        desc: "Informational values such as VWAP, Max Pain or reference levels.",
      },
      {
        title: "Signal Confluence",
        desc: "No single signal should be used in isolation. When three or more signals converge, confidence improves, but no signal guarantees results.",
      },
    ],
  },

  // {
  //   id: "indicator-reference",
  //   //: "📚",
  //   title: "Indicator Reference",
  //   purpose:
  //     "Explains the major technical indicators and calculations used by Quant Kubera.",
  //   points: [
  //     {
  //       title: "RSI",
  //       desc: "Relative Strength Index measures momentum on a 0-100 scale. Above 70 is overbought, below 30 is oversold.",
  //     },
  //     {
  //       title: "MACD",
  //       desc: "Moving Average Convergence Divergence uses MACD line, Signal line and Histogram to identify momentum shifts.",
  //     },
  //     {
  //       title: "VWAP",
  //       desc: "Volume Weighted Average Price represents institutional fair value. Above VWAP indicates buying strength.",
  //     },
  //     {
  //       title: "UT Bot",
  //       desc: "ATR-based trailing stop indicator. Bullish when price crosses above the stop and bearish when below.",
  //     },
  //     {
  //       title: "Bollinger Bands + AO",
  //       desc: "Bullish when bands expand upward with positive Awesome Oscillator. Bearish when bands expand downward with negative AO.",
  //     },
  //     {
  //       title: "Pivot Points",
  //       desc: "Support and resistance levels calculated using Classic, Fibonacci, Camarilla, Woodie and Demark methods.",
  //     },
  //     {
  //       title: "Moving Averages",
  //       desc: "SMA gives equal weight to prices. EMA gives more weight to recent prices.",
  //     },
  //     {
  //       title: "Closing Strength",
  //       desc: "Shows how strongly the stock closed within the day's range.",
  //     },
  //     {
  //       title: "Rebound Strength",
  //       desc: "Shows recovery from the session low.",
  //     },
  //     {
  //       title: "Distance to High",
  //       desc: "Shows how far the stock closed from the session high.",
  //     },
  //   ],
  // },
  {
    id: "indicator-reference",
    title: "Indicator Reference",
    purpose:
      "Explains the major technical indicators and calculations used by Quant Kubera.",
    points: [
      {
        title: "RSI",
        desc: "Relative Strength Index measures momentum on a 0-100 scale. Above 70 is overbought, below 30 is oversold.",
      },
      {
        title: "MACD",
        desc: "Moving Average Convergence Divergence uses MACD line, Signal line and Histogram to identify momentum shifts.",
      },
      {
        title: "VWAP",
        desc: "Volume Weighted Average Price represents institutional fair value. Above VWAP indicates buying strength.",
      },
      {
        title: "Smart Money",
        desc: "Composite money-flow signal that estimates accumulation and distribution using price and volume indicators.",
      },
      {
        title: "CMF",
        desc: "Chaikin Money Flow measures buying or selling pressure using the stock close position within the range and traded volume.",
      },
      {
        title: "OBV",
        desc: "On Balance Volume tracks whether volume supports price movement. Rising OBV suggests accumulation while falling OBV suggests distribution.",
      },
      {
        title: "RVOL",
        desc: "Relative Volume compares current volume with average volume to identify unusual market participation.",
      },
      {
        title: "MFI",
        desc: "Money Flow Index is a volume-weighted momentum indicator used in EOD Smart Money analysis.",
      },
      {
        title: "UT Bot",
        desc: "ATR-based trailing stop indicator. Bullish when price crosses above the stop and bearish when below.",
      },
      {
        title: "Bollinger Bands + AO",
        desc: "Bullish when bands expand upward with positive Awesome Oscillator. Bearish when bands expand downward with negative AO.",
      },
      {
        title: "Pivot Points",
        desc: "Support and resistance levels calculated using Classic, Fibonacci, Camarilla, Woodie and Demark methods.",
      },
      {
        title: "Moving Averages",
        desc: "SMA gives equal weight to prices. EMA gives more weight to recent prices.",
      },
      {
        title: "Closing Strength",
        desc: "Shows how strongly the stock closed within the day's range.",
      },
      {
        title: "Rebound Strength",
        desc: "Shows recovery from the session low.",
      },
      {
        title: "Distance to High",
        desc: "Shows how far the stock closed from the session high.",
      },
    ],
  },
  {
    id: "faq",
    //: "❓",
    title: "Frequently Asked Questions",
    purpose:
      "Common questions about data updates, signals, notifications and platform usage.",
    table: [
      {
        label: "When does data update?",
        value:
          "Quotes update every 1-2 minutes and signals update every 3 minutes during market hours.",
      },
      {
        label: "Why do Live Trend and EOD Trend differ?",
        value:
          "Live Trend uses intraday minute data. EOD Trend uses daily candle data.",
      },
      {
        label: "How do notifications work?",
        value:
          "Notifications are off by default. Enable the bell in Watchlist to receive email alerts.",
      },
      {
        label: "Can I place trades?",
        value:
          "No. Quant Kubera is an analytical platform only. Use your broker for trade execution.",
      },
      {
        label: "What is Kubera AI Assistant?",
        value:
          "A conversational AI assistant accessible through the floating AI //.",
      },
      {
        label: "What happens outside market hours?",
        value:
          "The platform shows last available session values. EOD Trend is most useful after market hours.",
      },
    ],
  },

  {
    id: "disclaimer",
    //: "⚠️",
    title: "Disclaimer & Risk Disclosure",
    purpose:
      "Important legal notice and risk information for all Quant Kubera users.",
    points: [
      {
        title: "Educational & Informational Purpose Only",
        desc: "All data, signals and analysis are strictly for educational and informational purposes only.",
      },
      {
        title: "No Financial Advice",
        desc: "Nothing on the platform constitutes financial advice or solicitation to buy or sell securities.",
      },
      {
        title: "Regulatory Status",
        desc: "PhronesisTech Private Limited is not registered with SEBI as an Investment Advisor, Research Analyst, Portfolio Manager or Stock Broker.",
      },
      {
        title: "Market Risk",
        desc: "Equity and F&O trading involve substantial risk, including possible loss of capital.",
      },
      {
        title: "No Performance Guarantees",
        desc: "Indicators and AI signals are based on probability, not certainty. Past performance does not guarantee future results.",
      },
      {
        title: "Technical Limitations",
        desc: "Platform availability and data accuracy are not guaranteed. Latency, downtime or data feed delays may occur.",
      },
      {
        title: "User Responsibility",
        desc: "Users retain full responsibility for all trading and investment decisions. Conduct your own due diligence or consult a SEBI-registered advisor.",
      },
    ],
  },
];
export const nseIndicesOptions = [
  "NIFTY 50",
  "NIFTY BANK",
  "NIFTY IT",
  "NIFTY NEXT 50",
  "NIFTY MIDCAP 50",
  "NIFTY MIDCAP 100",
  "NIFTY MIDCAP 150",
];
